module.exports = {"jugar":"Play","instrucciones":"Instructions"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locals/home/it.json
// module id = 175
// module chunks = 10